export const PATH_NAME = {
  DashboardAdminUser: '/DashboardAdmin/user',
  DashboardAdminParking: '/DashboardAdmin/parking',
  DashboardAdminParkingProcess: '/DashboardAdmin/parkingProcess',
  DashboardAdminPayment: '/DashboardAdmin/payment',
  DashboardAdminBanUser: '/DashboardAdmin/banUser',
  Profile: '/Profile',
  ERROR_404: '/404',
  HOME: '/home',
  Login: '/Login',
  Example: '/Example',
  DetailParking: '/DashboardAdmin/parking/:idParking',
};
